import React from "react";
import { useNavigate } from "react-router-dom";
import { X, Info, UploadCloud, AlertTriangle, CalendarClock, GitCompareArrows, FileWarning } from "lucide-react";

const ICONS = { UploadCloud, AlertTriangle, CalendarClock, GitCompareArrows, FileWarning };

export default function SuggestionCard({ suggestionKey, icon, title, subtitle, ctaLabel, ctaHref, onDismiss, testId }) {
  const navigate = useNavigate();
  const Icon = ICONS[icon] || Info;

  return (
    <section
      className="relative rounded-2xl border border-emerald-200 bg-emerald-50/40 p-6 flex items-center gap-4"
      data-testid={testId || `suggestion-${suggestionKey}`}
    >
      <div className="w-11 h-11 rounded-xl bg-emerald-100 grid place-items-center text-emerald-600 shrink-0">
        <Icon size={20} strokeWidth={1.75} />
      </div>
      <div className="flex-1 min-w-0">
        <p className="font-display font-bold text-qenva-navy text-[15px]">{title}</p>
        <p className="text-zinc-500 text-[12.5px]">{subtitle}</p>
      </div>
      {ctaHref && (
        <button
          type="button"
          onClick={() => navigate(ctaHref)}
          data-testid={`suggestion-${suggestionKey}-cta`}
          className="shrink-0 text-sm font-semibold text-emerald-700 hover:text-emerald-800 whitespace-nowrap"
        >
          {ctaLabel}
        </button>
      )}
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss"
        data-testid={`suggestion-${suggestionKey}-dismiss`}
        className="absolute top-3 right-3 w-6 h-6 grid place-items-center rounded-md text-zinc-400 hover:text-zinc-700 hover:bg-black/5"
      >
        <X size={14} />
      </button>
    </section>
  );
}
